<template>
  <b-modal title="Editar Compra" cancel-title="Cerrar" ok-title="Guardar" class="modal-success" v-model="open" @cancel="revert" @ok.prevent="actualizar" @hidden="clear">
      <div class="row">
          <div class="col-md-12">
              <b-form-group id="fecha" description="Fecha de compra" label="Fecha">
                  <b-form-input type="text" id="fecha" v-model.trim="draft.fecha" disabled></b-form-input>
              </b-form-group>
          </div>
          <div class="col-md-12">
              <b-form-group id="cantidad" description="Cantidad" label="Cantidad">
                  <b-form-input type="text" id="cantidad" v-model.trim="draft.timbres" disabled></b-form-input>
              </b-form-group>
          </div>
          <div class="col-md-12">
              <b-form-group id="Factura" description="Numero de factura" label="Factura">
                  <b-form-input type="text" id="Factura" v-model.trim="draft.factura"></b-form-input>
              </b-form-group>
          </div>
          <div slot="modal-footer" class="w-100">
              <div class="float-right">
                  <b-btn variant="secondary" @click="open=false">
                      Cerrar
                  </b-btn>
                  <b-btn :disable="loading" variant="primary" @click="actualizar">
                      Actualizar
                  </b-btn>
              </div>
          </div>
      </div>
  </b-modal>
</template>

<script>

import EventBus from '@/event-bus.js'

export default {
  name: 'editar',
  data () {
    return {
      open: false,
      draft: {},
      saved: ''
    }
  },
  methods: {
    actualizar () {
      var promise = this.$store.dispatch('actualizarCompra', this.draft)
      promise.then(response => {
        this.clear()
      }).catch(errorResponse => {
        this.errors = errorResponse.response.data
        this.loading = false
      })
    },
    clear () {
      this.open = false
      this.loading = false
    }
  },
  created () {
    EventBus.$on('OpenEditarCompra', response => {
      this.open = true
      this.draft = response
      this.saved = JSON.parse(JSON.stringify(response))
    })
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/Distribuidores/Historial/Editar.vue